module.exports = __webpack_public_path__ + "img/englishExam3.cfc8b49b.png";